import { ActionType, defaultAction } from 'src/redux/types';
import keyMirror from 'src/utilities/keyMirror';

const initialState = {
  sideModalOpen: false,
  individualWarningOpen: false,
};

export const USER_MANAGEMENT_ACTION_TYPES = keyMirror({
  SET_SIDE_MODAL: null,
  SET_WARNING_INDIVIDUAL: null,
});

export const userManagementReducer = (
  state = initialState,
  action: ActionType = defaultAction,
) => {
  switch (action.type) {
    case USER_MANAGEMENT_ACTION_TYPES.SET_SIDE_MODAL:
      return {
        ...state,
        sideModalOpen: action.payload,
      };
    case USER_MANAGEMENT_ACTION_TYPES.SET_WARNING_INDIVIDUAL:
      return {
        ...state,
        individualWarningOpen: action.payload,
      };
    default:
      return state;
  }
};
